import{b as r}from"../../_virtual/index.js";import{__exports as t}from"../../_virtual/base64url.js";import"./dist/base64url.js";var s;(s=r).exports=t.default,s.exports.default=s.exports;var a=r.exports;export{a as default};
